import ConfigProvider from '../config-provider';
import VirtualList from './virtual-list';

export default ConfigProvider.config(VirtualList);